<template>
  <div>
   <el-dialog  :append-to-body="appendToBody"  :visible.sync="dialogVisible" top="20%"  width="30%" :show-close="false" :close-on-click-modal="false">
     <div class="hetdel">
       <!-- 警告：warning 成功：success 失败：fail -->
      <div class="tubiao"><svg-icon :name="type" class="head"></svg-icon></div>
      <div class="rigtht">
        <div class="tab1">{{text}}</div>
        <div class="tab2">{{$t('components.promptInformation.thanks')}}</div>
      </div>
     </div>
     <div class="buton">
        <span class="butonmt sot" @click="butoe"> {{$t('components.promptInformation.backHome')}}</span>
       <!-- <span class="butonmt"><span>{{sats}}</span>秒后会自动返回首页，您也可以立即<span class="sot">返回首页</span></span> -->
     </div>
     </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'PromptInformation',
  props: {
    appendToBody: {
      type: Boolean,
      default: false
    },
  },
  data(){
    return{
      dialogVisible:false,
      sats:3,
      text:"",
      type:"",
      url:"",
    }
  },
  created () {
   this.open();
  },
  methods: {
    childMethods(v){
       this.text=v.text;
       this.type=v.type;
       this.url=v.routeUrl
       this.dialogVisible=true;
    },
    butoe(){
      this.dialogVisible=false;
      this.$router.push(this.url);
    },
    open(){
    //  const sendInterval = setInterval(() => {
    //     if (this.sats > 0) {
    //           this.sats -= 1
    //        } else {
    //           clearInterval(sendInterval)
    //           this.dialogVisible=false;
    //           }
    //        }, 1000);    
    }
  }
}
</script>

<style lang="scss" scoped>
.hetdel{
  display: flex;
  margin-bottom:50px;
 }
 .tab1{
    font-size: 14px; 
    color:#333333;
    font-weight: 500;
    line-height: 14px;
    text-align: center;
    word-break:break-word;
    margin-bottom:20px
 }
 .tab2{
    font-size: 12px;
    font-weight: 400;
    color: #666666;
    line-height: 20px;
    word-break:break-word;
    // text-align: center;
 }
 .tab3{
    font-size: 12px;
    font-weight: 400;
    color: #666666;
    line-height: 12px;
    text-align:right;
 }
.head {
    font-size: 30px;
   
  }
.tubiao{
   margin-top:10px;
  }
.rigtht{
   margin-left:20px ;
  }
.butonmt{
  float:right;
  font-size: 12px;
  font-weight: 400;
  color: #666666;
}
.sot{
  font-size: 14px;
  font-weight: 500;
  color: #EA5519;
  cursor:pointer;
}
.buton{
  padding-bottom:20px;
}
/deep/.el-dialog .el-dialog__header {
   border-bottom: 0px solid #d8dee6;
 }
</style>
